<template>
  <Panel
    class="overflow-hidden battle-royale-results-table px-0"
    :variant="[
      'transparent',
      'stroked',
      'stroked-input-borders',
      'rounded',
      'half-paddings',
    ]"
  >
    <div class="col">
      <Table
        :columns="columns"
        :items="sortedResults"
        :dummy-props="{
          iconName: 'dummy/members',
          size: 320,
          headerText: $$t('There are no participants yet', 'list-empty-state'),
          text: $$t('', 'list-empty-state_subheader'),
        }"
      >
        <div
          slot="head-item"
          slot-scope="{ column }"
          class="d-flex w-100 align-items-center"
          :class="[
            {
              'cursor-pointer': column.sort,
            },
            column.key === 'participants'
              ? 'justify-content-start'
              : 'justify-content-center',
          ]"
        >
          <TextBlock :size="0.75" :line-height="1.4" variant="secondary">
            {{
              $t(
                `_web_competitions_tournaments-list_col-title-${column.key}`,
                column.label
              )
            }}
          </TextBlock>
        </div>
        <template #body-item="{ item, column: { key }, index },">
          <template v-if="key === 'number'">
            <TextBlock :text="1 + index" />
          </template>
          <template v-if="key === 'participants'">
            <PlayersTableUsernameCell
              :key="$filters.displayName(playerProfile(item).profile)"
              :account="playerProfile(item).profile"
              :is-clan="playerProfile(item).profile.type === 'clan'"
            />
          </template>
          <TextBlock v-else :text="item[key]" />
        </template>
      </Table>
    </div>
  </Panel>
</template>

<script>
import { prop } from '@/utils/factories';
import listMixin from '@/mixins/paginatedLists';
import { translate } from '@/mixins/translate';
import TextBlock from '@/components/atoms/TextBlock';
import Table from '@/components/molecules/Table';
import PlayersTableUsernameCell from '@/views/tournaments/management/participants/components/PlayersTableUsernameCell';
import Panel from '@/components/atoms/Panel.vue';

export default {
  name: 'BattleRoyaleResults',
  components: {
    Table,
    Panel,
    TextBlock,
    PlayersTableUsernameCell,
  },
  mixins: [...listMixin, translate('_web_competitions_standings')],
  props: {
    results: prop(Array),
    players: prop(Array),
  },
  data() {
    return {
      standings: [],
    };
  },
  computed: {
    sortedResults() {
      return this.$lodash.sortBy(this.results, ['rank', (obj, index) => index]);
    },
    columns() {
      let cols;
      cols = this.battleRoyaleColumns();
      return this.$lodash.sortBy(cols, ['position', (obj, index) => index]);
    },
  },

  methods: {
    battleRoyaleColumns() {
      return [
        { label: '#', key: 'number' },
        { label: 'Participants', key: 'participants' },
        {
          label: 'Rank',
          key: 'rank',
          tooltip: null,
        },
        {
          label: 'Kills',
          key: 'kill_count',
          tooltip: null,
        },
      ];
    },
    playerProfile(item) {
      return this.players.find(p => p.profile.login == item.player_id);
    },
  },
};
</script>

<style lang="scss">
.battle-royale-results-table {
  max-width: 500px;
  padding: 0;

  .hera-table-wrap {
    padding: 0;
    background: transparent;
    .hera-table {
      background: transparent;
    }
    thead {
      background: transparent;
    }
    thead th,
    tbody td {
      &:nth-child(1) {
        width: 1px;
      }
      // &:nth-child(1),
      &:nth-child(n + 2) {
        text-align: center;
      }
    }
    tbody td {
      &:first-child {
        @include auto-rtl(padding-left, 0);
      }
      &:last-child {
        @include auto-rtl(padding-right, 0);
      }
    }
    thead th {
      position: sticky;
      top: 0;
      z-index: 2;
      margin-bottom: -$ph-large-space;
      background: transparent;
    }
    // .hera-table-control {
    //   padding: $ph-large-space;
    // }
    .hera-table-head {
      th {
        padding-right: 0.25rem;
        padding-left: 0.25rem;
        &:first-child {
          @include auto-rtl(padding-left, 0);
        }
        &:last-child {
          @include auto-rtl(padding-right, 0);
        }
        div {
          min-height: 1.5rem;
        }
      }

      .group-table-infotip {
        .playhera-icon {
          vertical-align: top !important;
          @include auto-rtl(margin-left, 0.15rem);
        }
      }
    }
    .players-table-username {
      max-width: 20rem;
    }
  }
}
</style>
